import {ref, Ref} from '@vue/composition-api';
import {EditorProps} from '../../../types';

interface LocalState {
	displayed: Ref<boolean>;
	createExport: Ref<boolean>;
	compressJs: Ref<boolean>;
	publishToIntegrations: Ref<boolean>;
}

export class EditorSaveOptionsControllerClass {
	private static _instance: EditorSaveOptionsControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorSaveOptionsControllerClass());
	}

	private constructor() {}

	private _state!: LocalState;
	init() {
		this._state = {
			displayed: ref(false),
			// let's have those set to true
			// as it makes things easier for newcomers
			createExport: ref(true),
			compressJs: ref(true),
			// but let's have this one false
			publishToIntegrations: ref(false),
		};
	}
	setFromEditor(props: EditorProps) {
		const saveOptions = props.saveOptions;
		if (saveOptions == null) {
			return;
		}
		// only use those values if they are present,
		// as they might not be when the schema changes
		if (saveOptions.createExport != null) {
			this._state.createExport.value = saveOptions.createExport;
		}
		if (saveOptions.compressJs != null) {
			this._state.compressJs.value = saveOptions.compressJs;
		}
		if (saveOptions.publishToIntegrations != null) {
			this._state.publishToIntegrations.value = saveOptions.publishToIntegrations;
		}
	}
	state() {
		return this._state;
	}
	editorLayoutData() {
		return {
			createExport: this._state.createExport.value,
			compressJs: this._state.compressJs.value,
			publishToIntegrations: this._state.publishToIntegrations.value,
		};
	}
	display() {
		this._state.displayed.value = true;
	}
}

export const SaveOptions = EditorSaveOptionsControllerClass.instance();
